module.exports = __webpack_public_path__ + "img/regiter-icon02-selected.c76f9635.png";